import { AdminEnvironment, CURRENT_ADMIN_ENVIRONMENT } from "environment";

type EnvironmentBadgeProps = {
  environment?: AdminEnvironment;
};

const environmentStyles: Record<
  AdminEnvironment,
  {
    borderColor: string;
    color: string;
    backgroundColor: string;
    labelBackgroundColor: string;
  }
> = {
  DEV: {
    borderColor: "#2f8f46",
    color: "#2f8f46",
    backgroundColor: "#eef8f1",
    labelBackgroundColor: "#cfead7",
  },
  HML: {
    borderColor: "#faad14",
    color: "#d48806",
    backgroundColor: "#fff8e7",
    labelBackgroundColor: "#f6ddb0",
  },
  PRD: {
    borderColor: "#ff4d4f",
    color: "#ff4d4f",
    backgroundColor: "#fff1f0",
    labelBackgroundColor: "#f3c5c3",
  },
};

export const EnvironmentBadge: React.FC<EnvironmentBadgeProps> = ({
  environment = CURRENT_ADMIN_ENVIRONMENT,
}) => {
  const style = environmentStyles[environment];

  return (
    <span
      aria-label={`Ambiente atual: ${environment}`}
      style={{
        border: `1px solid ${style.borderColor}`,
        borderRadius: 999,
        backgroundColor: style.backgroundColor,
        color: style.color,
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "3px 8px",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ color: "#333" }}>Ambiente atual:</span>
      <span
        data-testid="environment-badge-value"
        style={{
          alignItems: "center",
          backgroundColor: style.labelBackgroundColor,
          borderRadius: 999,
          color: style.color,
          display: "inline-flex",
          fontWeight: 500,
          gap: 8,
          lineHeight: 1,
          padding: "5px 10px",
        }}
      >
        <span
          data-testid="environment-badge-dot"
          style={{
            backgroundColor: style.color,
            borderRadius: "50%",
            display: "inline-block",
            height: 8,
            width: 8,
          }}
        />
        {environment}
      </span>
    </span>
  );
};
